/**
 * column range chart specific configurations
 * @type {Object}
 */
export const columnRangeChartConfiguration = {
  plotOptions: {
    columnrange: {
      grouping: false,
    },
    series: {
      groupPadding: 0.1,
      pointPadding: 0.1,
    },
  },
};
